import React, { createContext, useState } from "react";
import useFetch from "../../hooks/useFetch";

export const PurchasesContext = createContext();
PurchasesContext.displayName = "Purchases List Context";

export const PurchasesContextProvider = (props) => {
  const [purchases, setPurchases] = useState([]);
  const [maxPagination, setMaxPagination] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [latestQuery, setLatestQuery] = useState({});
  const [isLoadingPurchases, setIsLoadingPurchases] = useState(true);
  const { get } = useFetch();

  const getPurchases = async (queries = {}) => {
    setIsLoadingPurchases(true);
    setLatestQuery(queries);
    let url = "/suppliers/purchases?";

    Object.keys(queries).forEach(function (key, index) {
      url += key + "=" + queries[key] + "&";
    });

    get(url)
      .then((res) => {
        setPurchases(res.purchases);
        setMaxPagination(res.total);
        setCurrentPage(Number(res.page));
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => setIsLoadingPurchases(false));
  };

  const setPagination = (page) => {
    let newQuery = { ...latestQuery };
    newQuery.page = page;
    getPurchases(newQuery);
  };

  return (
    <PurchasesContext.Provider
      value={{
        getPurchases,
        setPagination,
        purchases,
        maxPagination,
        currentPage,
        isLoadingPurchases,
      }}
    >
      {props.children}
    </PurchasesContext.Provider>
  );
};
